import React from 'react';

import PopupContainer from '../PopupContainer';
import PopupContent from '../PopupContent';

const Content = () => {
  return (
    <PopupContainer isRound size="big">
      <PopupContent>
        hola
      </PopupContent>
    </PopupContainer>
  );
}

export default Content;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentSchedulePopUp/Content.jsx